<template>
  <ElDropdown :trigger="'click'" @command="switchLanguage">
    <span class="el-dropdown-link">
      <span class="flex mt-1 gap-x-1 border border-gray-200 px-1.5 py-1 items-center rounded-md">
        <WorldIcon />
        <span v-if="!isMobile()">{{ selectedLanguage.key.toUpperCase() }}</span>
        <WcIconArrowUp color="rgba(4, 4, 16, 0.60)"/>
      </span>
    </span>
    <ElDropdownMenu>
      <ElRadioGroup v-model="selectedLanguage.key">
        <ElDropdownItem v-for="(item, index) of languageList" :key="index" :command="item['key']">
          <ElRadio :value="item['key']" :label="item['key']" :class="item['key']===selectedLanguage.key ? 'text-black' : 'text-gray-500' " >
            {{ item['label'] }}</ElRadio>
        </ElDropdownItem>
      </ElRadioGroup>
    </ElDropdownMenu>
  </ElDropdown>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { LanguageEnum, LanguageModule } from '@/store/modules/language'
import Button from '@/components/UILibrary/Buttons/Button.vue'
import WcIconArrowUp from '@/components/UILibrary/Icons/WcIconArrowUp.vue'
import WcIconUserFilled from '@/components/UILibrary/Icons/WcIconUserFilled.vue'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import WorldIcon from '@/components/UILibrary/Icons/WorldIcon.vue'
import { isMobile } from '@/utils/general'

@Component({
  methods: { isMobile },
  components: { WorldIcon, WcTypography, WcIconUserFilled, WcIconArrowUp, Button },
  computed: {
    LanguageEnum() {
      return LanguageEnum
    },
    getCurrentLanguage() {
      return LanguageModule.language
    }
  }
})
export default class extends Vue {
  switchLanguage(switchTo: LanguageEnum) {
    LanguageModule.setLanguage(switchTo)
    this.selectedLanguage.key = switchTo
    this.selectedLanguage.label = this.languageList.find((item) => item.key === LanguageModule.language)?.label || ''
  }

  languageList: {key: LanguageEnum, label: string}[] = [{
    key: LanguageEnum.ENGLISH,
    label: 'English - EN'
  },
  {
    key: LanguageEnum.ARABIC,
    label: 'العربية - AR'
  }
  ]

  selectedLanguage: {key: LanguageEnum, label: string} = {
    key: LanguageModule.language,
    label: this.languageList.find((item) => item.key === LanguageModule.language)?.label || ''
  }

  @Watch(LanguageModule.language)
  onLanguageChange() {
    this.switchLanguage(LanguageModule.language)
  }
}
</script>

<style scoped>
.el-radio__input.is-checked + .el-radio__label {
  color: black;
}
</style>
